import { CircleX } from "lucide-react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { FormLabel, FormMessage } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { DayIntervalsFields } from "./day-intervals-fields.content";
import { formatHoursDisplay } from "./training-schedule-form.utils";
import type { TrainingDateRowProps } from "./training-schedule-form.types";

export const TrainingDateRow = ({
  date,
  index,
  morning,
  afternoon,
  dayHours,
  onHalfDayChange,
  onRemove,
  renderHalfDayExtra,
}: TrainingDateRowProps) => {
  return (
    <div className="rounded-lg border p-4">
      <div className="mb-4 flex items-center justify-between">
        <FormLabel className="text-base">{`Jour ${index + 1} : ${format(date, "EEEE d MMMM yyyy", { locale: fr })}`}</FormLabel>
        <button
          type="button"
          className="cursor-pointer bg-transparent text-red-500 opacity-100 hover:text-red-700"
          onClick={onRemove}
          title="Supprimer cette date"
        >
          <CircleX className="size-5" />
        </button>
      </div>

      <div className="space-y-3">
        <DayIntervalsFields
          morning={morning}
          afternoon={afternoon}
          onHalfDayChange={onHalfDayChange}
          renderHalfDayExtra={renderHalfDayExtra}
        />

        <FormMessage />

        <div className="flex items-center justify-end gap-2 text-sm">
          <span className="text-muted-foreground">Durée :</span>
          <span className="font-semibold">{formatHoursDisplay(dayHours)}</span>
        </div>
      </div>
    </div>
  );
};
